// eslint-disable-next-line import/prefer-default-export

import Body from './components/Body';
import Headline from './components/Headline';
import Label from './components/Label';
import Title from './components/Title';

export { default as bodyStyling } from './styles/body';
export { default as buttonTextStyling } from './styles/buttonText';
export { default as headlineStyling } from './styles/headline';
export { default as linkTextStyling } from './styles/linkText';
export { default as titleStyling } from './styles/title';

export { Headline };
export { Title };
export { Body };
export { Label };

export const Typography = {
    Headline,
    Title,
    Body,
    Label
};
